module.exports = " <form :action=\"filesaver.url + '?access_token=' + access_token\" method=post target=_blank> <input type=hidden v-for=\"(key, value) in filesaver.props\" :name=key :value=value> </form> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/app/filesaver/FileSaver.vue
// module id = 159
// module chunks = 0